// src/stores/uiStore.js
import { defineStore } from "pinia";
import { ref } from "vue";

export const useUIStore = defineStore("uiStore", () => {
  
  // 'analysis' ou 'chat'
  const rightPanelMode = ref('analysis');
  
  // Unread chat messages count
  const unreadChatCount = ref(0);
  
  function showAnalysis() {
    rightPanelMode.value = 'analysis';
  }
  
  function showChat() {
    rightPanelMode.value = 'chat';
    unreadChatCount.value = 0; // Clear badge
  }
  
  function togglePanel() {
    if (rightPanelMode.value === 'analysis') {
      showChat();
    } else {
      showAnalysis();
    }
  }
  
  function incrementUnread() {
    if (rightPanelMode.value !== 'chat') {
      unreadChatCount.value++;
    }
  }
  
  return {
    rightPanelMode,
    unreadChatCount,
    showAnalysis,
    showChat,
    togglePanel,
    incrementUnread
  };
});